import { useSelector, shallowEqual } from 'react-redux';
import { TestVariation } from 'redux-implementations/optimizelyDecisions';
import State, { OptimizelyDecisionsSlice } from 'types/State';

export interface OptimizelyDecisionsParams {
  getDecision: (testName: string) => boolean;
  allDecisions: Record<string, TestVariation>;
}

export default function useOptimizelyDecisions(): OptimizelyDecisionsParams {
  const decisions = useSelector<State, OptimizelyDecisionsSlice>(
    (state) => state.optimizelyDecisions,
    shallowEqual
  );

  const allDecisions: Record<string, TestVariation> = {
    vdpStickyCta4: decisions?.vdp_sticky_cta_take4 || 'off',
    onlineToOfflineV1: decisions?.['o2o-0_5-consumer-v1'] || 'off',
    smsFunctionality: decisions?.sms_functionality || 'off',
    mutliMakeModel: decisions?.multi_make_model || 'off',
  };

  function getDecision(testName: string): boolean {
    return allDecisions[testName] === 'on' || false;
  }

  return {
    getDecision,
    allDecisions,
  };
}
